import React from "react";
import { NavigatorAction } from "../../../../flux";
export default class Instructions extends React.Component {
  constructor() {
    super();
    this.copyUrl = this.copyUrl.bind(this);
    this.preview = this.preview.bind(this);
  }

  copyUrl() {
    Fraction.Helpers.copyText(this.props.url);
    Fraction.Helpers.toast(i18n.t("assignments.copied"), { centered: true });
  }

  preview() {
    window.open(`#${this.props.url.split("#")[1]}`, "_blank");
  }

  render() {
    const { url, vbid, uuid } = this.props;
    return (
      <span>
        <div id="success-instructions">
          {i18n.t("assignments.copy-link-instruction")}
        </div>
        <div className="assignment-url">{url}</div>
        <div className="actions">
          <button className="button submit" onClick={this.copyUrl}>
            {i18n.t("assignments.copy-link")}
          </button>
          <button
            className="button submit gray"
            onClick={this.preview}
            role="link"
            target="_blank"
          >
            {i18n.t("base.preview")}
            <span className="offScreen">{i18n.t("base.new-window")}</span>
          </button>
          <button className="button submit gray" onClick={NavigatorAction.pop}>
            {i18n.t("base.edit")}
          </button>
          <a
            className="button submit link"
            href={`${window.location.origin}/#/assignments`}
          >
            {i18n.t("assignments.back-all-assignments")}
          </a>
        </div>
      </span>
    );
  }
}
